import React, { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AppLogo from '../components/AppLogo';
import AppTitle from '../components/AppTitle';
import PageLoader from '../components/PageLoader';
import '../App.css';

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import _ from 'lodash';

import Auth from '../core/services/auth';

function Accept() {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [ loading, setLoading ] = useState(false)
    const [ response, setResponse ] = useState<any>()

    const params = useParams();
    
    useEffect(() => {

        if (!Auth.isAuthenticated()) {
          navigate('/login', { state: { id: params.id, page: 'accept' } })
          return;
        } 

        else if (!params) {
            navigate('/splashscreen');
        }

        else if (!state && params) {

            setLoading(true)

            Auth.api.get('vendor-admins/accept/'+params.id).then(res=> {

                setLoading(false)

                setResponse(res.data.message)
        
                toast.success(res.data.message, {
                  position: "top-center",
                });
        
                setTimeout(()=>{
                  // navigate 
                  navigate('/') 
        
                }, 3500) 
        
              }).catch(err=>{
        
                // console.log(err)
        
                setLoading(false)
        
                if (_.isArray(err.response.data.error)) {
                  let error = err.response.data.error
                  //
                  for (let index = 0; index < error.length; index++) {
                    const err = error[index];
                    toast.error(err.message, {
                      position: "top-center",
                    });
                  }
                } else {
                  toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                    position: "top-center",
                  });
                }
        
              })
        }
        
        // if (id) {
            // verifyVendorLink()
        // }
    },[navigate, params, state])

    return (
        <section className=''>
          <div className="flex flex-col items-center justify-center px-6 py-4 mx-auto h-[95vh] ">
          
          { loading ? <PageLoader /> : '' }
          <ToastContainer />
            <AppLogo />
            <AppTitle title={'Vendor Admin Verify'} description={'Verification for vendor Admins'} />
            
            <div className="invisible w-full md:mt-0 sm:max-w-md xl:p-0 mt-5">
              <div className="p- space-y-4 md:space-y-6 sm:p-8">
                  {/* <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                      Sign in to your account
                  </h1> */}
                  {response}
                  
              </div>
            </div>

          </div>
        </section>
    );
  }
  

  export default Accept;
